import { render, staticRenderFns } from "./FPZ.vue?vue&type=template&id=00b4f148&scoped=true"
import script from "./FPZ.vue?vue&type=script&lang=js"
export * from "./FPZ.vue?vue&type=script&lang=js"
import style0 from "./FPZ.vue?vue&type=style&index=0&id=00b4f148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b4f148",
  null
  
)

export default component.exports